import React, { useState, useEffect } from 'react'
import { api } from 'src/utils';
import { Button, Box, TextFieldInput, Loader } from 'src/components';
import { ProfileViewHeader } from '../index';

export default function ForgotPassword({ handleCurrentViewChange, handleSuccess }) {
    const [loading, set_loading] = useState(false);
    const timer = React.useRef();

    useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
    }, []);

    const handleForgotPassword = async (e) => {
        if (!loading) {
            set_loading(true);
            e.preventDefault();
            const data = e.target;
            timer.current = window.setTimeout(async () => {
                try {
                    await api.post('/auth/forgot-password', { email: data.email.value });
                    handleSuccess("Recovery email sent!");
                    handleCurrentViewChange("RecoverPassword");
                } catch (err) {
                    console.log(err);
                }
                set_loading(false);
            }, 1000);
        }
    };

    return (
        <div>
            <ProfileViewHeader title="Forgot Password?" subtitle="Submit your email and we will send you a new one" handleCurrentViewChange={handleCurrentViewChange} backTo="Login" alternateActionText="Already received a code?" alternateActionPage="RecoverPassword" alternateActionPageName="Enter Code" />

            <Box component="form" onSubmit={handleForgotPassword} sx={{ mb: 1 }}>

                <TextFieldInput id="email" label="Email Address" type="text"/>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    className="submit-button button"
                    disabled={loading}>
                    Recover Password
                </Button>

                {loading && (<Loader />)}

            </Box>
        </div>
    );
}
